const WANYOL_CN = 'owork-webplat-cn.wanyol.com'
const WANYOL_CN_TEST = 'owork-webplat-cn-test.wanyol.com'
const PRE_CLOUD_HEYTAP = 'cloud-pre.heytap.com'
const PRE_CLOUD_OPPO = 'cloud-pre.oppo.com'
const CLOUD_REALME = 'cloud.realme.com'
const CLOUD_HEYTAP = 'cloud.heytap.com'
const CLOUD_OPPO = 'cloud.oppo.com'
const WANYOL_CLOUD = 'heytap-web-ocloudzx.wanyol.com'

const metaTagName = 'ignore-slide-screen'

const ignoreSlideScreenKeyMap = new Map([
  [WANYOL_CN, 'd30653ecc9c3a70f43afde4a1d817888|1829664000'],
  [WANYOL_CN_TEST, '4ea08441c78898296aae0908cff4de28|1830182400'],
  [PRE_CLOUD_HEYTAP, '9b6f183931b5ec3478b44ec0648661c9|1767110400'],
  [PRE_CLOUD_OPPO, '0338a233cb90b68ad1111154a205f0ad|1767110400'],
  [CLOUD_REALME, 'c1aed793f45e0b013896d5353abffc5e|1767110400'],
  [CLOUD_HEYTAP, '6e93ac2cca833e95234686ea1e1b6c3a|1767110400'],
  [CLOUD_OPPO, 'a25ec38c9da7e54167ed7ff7c6d43c5c|1767110400'],
  [WANYOL_CLOUD, '3a03f28521cd02e74577a408a21a1c1b|1798646400'],
])

export const useDisableSlide = () => {
  const ignoreSlideScreenKey = ignoreSlideScreenKeyMap.get(window.location.hostname)

  if (ignoreSlideScreenKey) {
    const metaTag = document.createElement('meta')

    metaTag.name = metaTagName
    metaTag.content = ignoreSlideScreenKey
    document.head.appendChild(metaTag)
  }
}
